/**
 * Component: Expected delivery
 * ------------------------------------------------------------------------------
 * Display expected delivery days on PDP.
 *
 * @namespace expectedDelivery
 */
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range'
import cssClasses from '../helpers/cssClasses'
import DeliveryDates from '../helpers/DeliveryDates'
import log from 'salvo-lite/log'

class ExpectedDelivery {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            deliveryMessage: '[data-expected-delivery-message]',
            lifestyleProduct: 'lifestyle_product',
            ...JSON.parse(elem.getAttribute('data-expected-delivery') || '{}')
        }

        /**
         * Declare global moment local time.
         */
        moment.updateLocale('en', {
            relativeTime: {
                future: '%s'
            }
        })

        /**
         * Declare timezone and locales.
         */
        this._timezone = 'Europe/London'
        if (window.theme.store.id === 'de_store') {
            this._timezone = 'Europe/Berlin'
            moment.locale('de')
        } else {
            moment.locale('en')
        }

        /**
         * Format cut off time.
         */
        let cutOffTime = window.theme.deliveryDays.deliveryCuttOff
        cutOffTime = cutOffTime.split(':')
        const hours = cutOffTime[0]
        const minutes = cutOffTime[1]

        /**
         * Date Variables.
         */
        this._dateFormat = 'YYYYMMDD.HHmmss'
        this._cutOffDate = moment
            .tz(this._timezone)
            .hour(hours)
            .minutes(minutes)
            .seconds(0)
        this._currentTime = moment.tz(this._timezone).format(this._dateFormat)

        /**
             * DOM node selectors.
             */
        this._nodeSelectors = {
            deliveryMessage: this._elem.querySelector(this._settings.deliveryMessage)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        if (this._productUnavailable() || this._restrictedProduct()) {
            this._elem.classList.add(cssClasses.hidden)
            return
        }

        this._setIntervalCheck()
    }

    /**
     * Set interval check.
     */
    _setIntervalCheck () {
        const checkTime = window.setInterval(() => {
            this._currentTime = moment.tz(this._timezone).format(this._dateFormat)

            if (this._isBeforeCutOff()) {
                this._insertMessageBlock()
                return
            }

            window.clearInterval(checkTime)

            this._insertMessageBlock()
        }, 1000)
    }

    /**
     * Insert delivery message depending on product type and cut off time.
     */
    _insertMessageBlock () {
        let deliveryDate = ''
        const productType = this._nodeSelectors.deliveryMessage.getAttribute('data-product-type')

        if (productType === this._settings.lifestyleProduct) {
            deliveryDate = new DeliveryDates(window.theme.deliveryDays.lifestyleDeliveryBeforeCutOff, window.theme.deliveryDays.lifestyleDeliveryAfterCutOff, 'DD/MM/YYYY').onInit()
        } else {
            deliveryDate = new DeliveryDates(window.theme.deliveryDays.carPartsDeliveryBeforeCutOff, window.theme.deliveryDays.carPartsDeliveryAfterCutOff, 'DD/MM/YYYY').onInit()
        }

        this._nodeSelectors.deliveryMessage.innerHTML = `<p>${window.theme.deliveryDays.deliveryTitle}:</p><p>${deliveryDate}</p>`
    }

    /**
     * Check cut off time.
     */
    _isBeforeCutOff () {
        return this._currentTime <= this._cutOffDate.format('YYYYMMDD.HHmmss')
    }

    /**
     * Check if product is available.
     */
    _productUnavailable () {
        return !window.ProductJSON.available
    }

    /**
     * Check if product has dispatch-countdown restriction.
     */
    _restrictedProduct () {
        const restrictedTags = ['Catalogue_Product', 'Installation_Bundle']
        const productTags = window.ProductJSON.tags
        const tagGroup = productTags.map((tag) => tag.split(':').shift())

        return tagGroup.some((element) => restrictedTags.includes(element))
    }

    /**
     * Expose public interface.
     */
    //   return Object.freeze({
    //     init,
    //   })
}

export default ExpectedDelivery



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ExpectedDelivery.js